"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupAuthInterceptor = exports.setupOpenApiFixupInterceptor = void 0;
const axios_1 = __importDefault(require("axios"));
let openApiFixupSetup = false;
const setupOpenApiFixupInterceptor = () => {
    if (openApiFixupSetup)
        return;
    axios_1.default.interceptors.request.use(function (config) {
        if (config.headers['Content-Type'] === 'application/json' &&
            typeof config.data === 'string') {
            config.data = JSON.parse(config.data);
        }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    openApiFixupSetup = true;
};
exports.setupOpenApiFixupInterceptor = setupOpenApiFixupInterceptor;
let isAuthSetup = false;
const setupAuthInterceptor = (accessToken) => {
    if (isAuthSetup)
        return;
    axios_1.default.interceptors.request.use(function (config) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
        console.log(config.headers['Authorization']);
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    isAuthSetup = true;
};
exports.setupAuthInterceptor = setupAuthInterceptor;
//# sourceMappingURL=interceptors.js.map